module.exports = __webpack_public_path__ + "static/media/b.1ec4625d.svg";